import { useState, useEffect, useRef } from 'react';
import Dropdown from './Dropdown';
import { Link } from 'react-router-dom';


const MenuItems = ({ items, depthLevel }) => {
    const [dropdown, setDropdown] = useState(false);

    let ref = useRef();

    useEffect(() => {
        const handler = (event) => {
            if (
                    dropdown &&
                    ref.current &&
                    !ref.current.contains(event.target)
                    ) {
                setDropdown(false);
            }
        };
        document.addEventListener('mousedown', handler);
        document.addEventListener('touchstart', handler);
        return () => {
            document.removeEventListener('mousedown', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [dropdown]);

    const onMouseEnter = () => {
        window.innerWidth > 960 && setDropdown(true);
    };

    const onMouseLeave = () => {
        window.innerWidth > 960 && setDropdown(false);
    };

    const closeDropdown = () => {
        dropdown && setDropdown(false);
    };

    return (
            <li
                className={`menu-items ${depthLevel === 0 ? 'top-level' : ''}`}
                ref={ref}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
                onClick={closeDropdown}
                >
                {items.action && items.children.length > 0 ? (
                                    <>
                                    <button
                                        type="button"
                                        aria-haspopup="menu"
                                        aria-expanded={dropdown ? 'true' : 'false'}
                                        onClick={() => setDropdown((prev) => !prev)}
                                        >
                                        {window.innerWidth < 960 && depthLevel === 0 ? (
                                                        items.label
                                                        ) : (
                                                                <Link>{items.label}</Link>
                                                        )}
                                
                                        {depthLevel > 0 &&
                                                        window.innerWidth < 960 ? null : depthLevel > 0 &&
                                                        window.innerWidth > 960 ? (
                                                                        <span className="arrow-right" />
                                                                ) : (
                                                                <span className="arrow" />
                                                        )}
                                    </button>
                                <Dropdown
                                    depthLevel={depthLevel}
                                    childrens={items.children}
                                    dropdown={dropdown}
                                    />
                                </>
                                ) : !items.action && items.children.length > 0 ? (
                            <>
                            <button
                                type="button"
                                aria-haspopup="menu"
                                aria-expanded={dropdown ? 'true' : 'false'}
                                onClick={() => setDropdown((prev) => !prev)}
                                >
                                {items.label}{' '}
                                {depthLevel > 0 ? (
                                                <span>&raquo;</span>
                                            ) : (
                                                <span className="arrow" />
                                            )}
                            </button>
                            <Dropdown
                                depthLevel={depthLevel}
                                childrens={items.children}
                                dropdown={dropdown}
                                />
                            </>
                        ) : (
                            <Link to={items.action.isFileContent === '1' ? items.action.content : 'ContentById/' + items.action.content}>{items.label}</Link>
                        )}
            </li>
            );
};

export default MenuItems;